import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue';
import AuthView from '../views/AuthView.vue';
import AdminView from '../views/AdminView.vue';
import ArticleView from '../views/ArticleView.vue';
import { userService } from '../services/user.service';
import GiveawayView from '../views/GiveawayView.vue';
import LogoutView from '../views/LogoutView.vue';
import BountyHunter from '../views/BountiesView.vue';
import BountyDetailView from '../views/BountyDetailView.vue';
import JukeboxView from '../views/JukeboxView.vue';
import GamesView from '../views/GamesView.vue';
import BracketView from '../views/BracketView.vue';
import BracketHistory from '../views/BracketHistoryView.vue';
import RoadmapView from '../views/RoadmapView.vue';
import TeamView from '../views/TeamView.vue';
import ManageArticlesView from '../views/ManageArticlesView.vue';
import EditArticleView from '../views/EditArticleView.vue';
import FGCView from '../views/FGCView.vue';
import FGCPrizePoolView from '../views/FGCPrizePoolView.vue';
import FGCObsView from '../views/FGCObsView.vue';
import FGCAdminView from '../views/FGCAdminView.vue';
import GuesserView from '../views/GuesserView.vue';
import GuesserAdminView from '../views/GuesserAdminView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import BRollRequestView from '../views/BRollRequestView.vue';

async function authGuard(to: any): Promise<any> {
  await userService.ready;
  if (!userService.jwt) {
    localStorage.setItem('authFailedPath', JSON.stringify(to));
    return { name: 'login' };
  }
  return true;
}

async function adminGuard(to: any): Promise<any> {
  await userService.ready;
  if (!userService.admin) {
    localStorage.setItem('authFailedPath', JSON.stringify(to));
    return { name: 'login' };
  }
  return true;
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/article/:id',
    name: 'article',
    component: ArticleView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/Logout',
    name: 'Logout',
    component: LogoutView
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthView
  },
  {
    path: '/giveaways',
    name: 'giveaways',
    component: GiveawayView,
    beforeEnter: authGuard,
  },
  {
    path: '/bounties',
    name: 'bounties',
    component: BountyHunter,
    beforeEnter: authGuard,
  },
  {
    path: '/bounties/:id',
    name: 'bountiesDetail',
    component: BountyDetailView,
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    beforeEnter: adminGuard,
  },
  {
    path: '/admin/articles',
    name: 'manage-articles',
    component: ManageArticlesView,
    beforeEnter: adminGuard,
  },
  {
    path: '/admin/articles/:id',
    name: 'edit-article',
    component: EditArticleView,
    beforeEnter: adminGuard,
  },
  {
    path: '/jukebox',
    name: 'jukebox',
    component: JukeboxView,
  },
  {
    path: '/games',
    name: 'games',
    component: GamesView,
  },
  {
    path: '/bracket',
    name: 'bracket',
    component: BracketView,
  },
  {
    path: '/bracket-history',
    name: 'bracket-history',
    component: BracketHistory,
  },
  {
    path: '/roadmap',
    name: 'roadmap',
    component: RoadmapView,
  },
  {
    path: '/team/:tab?',
    name: 'team',
    component: TeamView,
  },
  {
    path: '/bgg_fgc',
    name: 'fgc',
    component: FGCView,
  },
  {
    path: '/bgg_fgc/prize-pool/:game',
    name: 'fgc-prize-pool',
    component: FGCPrizePoolView,
  },
  {
    path: '/bgg_fgc/prize-pool',
    redirect: '/bgg_fgc/prize-pool/tekken8',
  },
  {
    path: '/bgg_fgc_obs',
    name: 'fgc-obs',
    component: FGCObsView,
  },
  {
    path: '/admin/fgc',
    name: 'fgc-admin',
    component: FGCAdminView,
    beforeEnter: adminGuard,
  },
  {
    path: '/game_guesser',
    name: 'guesser',
    component: GuesserView,
  },
  {
    path: '/guesser',
    redirect: '/game_guesser',
  },
  {
    path: '/admin/guesser',
    name: 'guesser-admin',
    component: GuesserAdminView,
    beforeEnter: adminGuard,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicyView,
  },
  {
    path: '/broll-request',
    name: 'broll-request',
    component: BRollRequestView,
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router


